/**
 * Room Data Transfer Object
 * Represents a normalized Room entity with validation
 */

import { DeviceDTO } from './DeviceDTO';

export interface IRoomData {
  uid?: string;
  id?: string;
  roomUid?: string;
  roomId?: string;
  name?: string;
  title?: string;
  label?: string;
  homeUid?: string | null;
  devices?: any[];
  gateways?: any[];
}

export class RoomDTO {
  readonly uid: string;
  readonly name: string;
  readonly homeUid: string | null;
  readonly devices: DeviceDTO[];
  readonly gateways: any[];

  constructor(data: IRoomData) {
    this.uid = this.validateRequired(
      data.uid || data.id || data.roomUid || data.roomId,
      'uid'
    );
    this.name = data.name || data.title || data.label || `Room ${this.uid}`;
    this.homeUid = data.homeUid || null;
    this.devices = Array.isArray(data.devices)
      ? data.devices.map(d => new DeviceDTO(d))
      : [];
    this.gateways = Array.isArray(data.gateways) ? data.gateways : [];
  }

  private validateRequired(value: any, fieldName: string): string {
    if (value === undefined || value === null || value === '') {
      throw new Error(`RoomDTO: ${fieldName} is required`);
    }
    return String(value);
  }

  /**
   * Create DTO from API response
   */
  static fromApiResponse(apiData: IRoomData): RoomDTO {
    return new RoomDTO(apiData);
  }

  /**
   * Convert to plain object for store
   */
  toStoreEntity() {
    return {
      uid: this.uid,
      name: this.name,
      homeUid: this.homeUid,
      devices: this.devices.map(d => d.toStoreEntity()),
      gateways: this.gateways,
    };
  }
}
